import React from "react";
import {ItemInMenuDto} from "../../../dtos";
import {ItemInMenuContent} from "./itemInMenuContent/itemInMenuContent";
import {MenuItem} from "@mui/material";
import {useTypedSelector} from "../../../hooks/useTypeSelector";

interface Props {
    item: ItemInMenuDto,
    onClick: (e: React.MouseEvent) => void,
    setOpen: (a: boolean) => {}
}


export const ItemInMenu = (props: Props) => {
    let {uploadImagesPopup} = useTypedSelector((state) => state);
    return (
        <MenuItem
            title={`${props.item.code === "UploadPromoImages" || props.item.code === "UploadItemImages" && !uploadImagesPopup.processingFinished ? "An upload is still in process" : props.item.tooltip !== '' ? props.item.tooltip : ''}`}
            sx={{
            padding: `10px`,
            fontSize: `14px`,
            justifyContent: 'flex-start'
        }}>
            <ItemInMenuContent item={props.item} setOpen={props.setOpen}/>
        </MenuItem>
    )
}